import React, { useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CarouselJobItem from "./CarouselJobItem";
import { Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const JobCarousel = ({ adverts }) => {
  let sliderRef = useRef(null);

  const next = () => {
    sliderRef.slickNext();
  };

  const previous = () => {
    sliderRef.slickPrev();
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <div
      className="job-carousel-content"
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        position: "relative",
      }}>
      <div style={{ position: "relative" }}>
        <Button
          icon={<LeftOutlined />}
          onClick={previous}
          style={{
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 1,
            borderRadius: "50%",
            backgroundColor: "#ffffff",
            border: "1px solid #ddd",
            height: "30px",
            width: "30px",
          }}
        />

        <Slider
          ref={(slider) => {
            sliderRef = slider;
          }}
          {...settings}>
          {adverts.map((job, index) => (
            <CarouselJobItem key={index} job={job} />
          ))}
        </Slider>

        <Button
          icon={<RightOutlined />}
          onClick={next}
          style={{
            position: "absolute",
            right: 0,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 1,
            borderRadius: "50%",
            backgroundColor: "#ffffff",
            border: "1px solid #ddd",
            height: "30px",
            width: "30px",
          }}
        />
      </div>
    </div>
  );
};

export default JobCarousel;
